/**
 * @param legendData 提示栏数据
 * @param title 标题
 * @param ySuffix 后缀
 * @param endValue 设置每一页的最大显示个数+1
 * @param rotate 倾斜角度
 */
export default function (legendData = [], title = '', ySuffix = '', endValue = 7, rotate = 0) {
  const data = {
    additionalInfo: {
      title: '',
      values: [],
      key: ''
    },//附加信息
    title: {
      show: !!title,
      text: title,//需要改变的数据
      top: '4%',
      left: '2%',
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        lineStyle: {
          color: "#86909C", //显示竖线颜色
          type: "dashed",
        },
      },
      backgroundColor: "none", //tooltip背景色
      borderColor: "rgba(204,204,204,0.1)", //tooltip边框颜色
      borderWidth: 1,
      borderRadius: 4,
      width: 300,
      formatter: function (param) {
        let text = '';
        if (param.length) {
          const additionalInfo = data.additionalInfo
          text += `<div style="background: rgba(204,204,204,0.1);border-radius:4px;padding:8px;backdrop-filter: blur(5px);box-shadow: 0px 0px 16px 0px rgba(29,48,92,0.15);display: flex;flex-direction: column;position: relative;">
                          <h2 style="color:#1D2129;font-size:12px;">${title}</h2>`;
          for (let i = 0; i < param.length; i++) {
            text += `<div style="background:#ffffff;border-radius:6px;margin:4px;padding:4px 8px;color:#000000;display: flex;align-items: center">
                            <b style="display:inline-block;border: 2px solid #f0f0f0;width:8px;height:8px;border-radius:6px;background-color:${param[i].color}"></b>
                            <span style="color:#4E5969;font-size:12px;margin-left: 2px">${param[i].seriesName} </span>
                            <span style="color:#1D2129;font-size:12px;margin-left: 2px">${param[i].value}${ySuffix}</span>
                          </div>`
          }
          if (additionalInfo && additionalInfo.values && additionalInfo.values.length) {
            let str = ''
            const title = (additionalInfo.values[param[0].dataIndex][additionalInfo.key]) || ''
            if (title.length > 10) {
              for (let j = 0; j < title.length; j += 10) {
                let s = (j >= 10) ? '<br>' : ''
                str += s + title.slice(j, j + 10)
              }
            }else {
              str = title
            }
            text += `<div style="background:white;border-radius:6px;margin:4px;padding:4px 8px;color:#000000;display: flex;align-items: center;">
                <span style="color:#1D2129;font-size:12px;margin-left: 2px;">${additionalInfo.title}：<br>${str}</span>
              </div>`
          }
          text += `</div>`;
        }
        return text;
      },
    },
    color: ['#FFC300', '#43CF7C', '#5B8FF9'],
    legend: {
      icon: 'rect',
      align: 'right',
      itemWidth: 20,
      itemHeight: 4,
      left: '11%',
      top: '12%',
      data: legendData,//需要改变的数据
      selectedMode: legendData.length > 1,
      textStyle: {
        fontSize: 12
      }
    },
    grid: {
      top: '25%',
      left: '7%',
      right: '6%',
      containLabel: false
    },
    xAxis: {
      type: 'category',
      data: [],//需要改变的数据
      axisTick: {
        alignWithLabel: true
      },
      axisLine: {
        lineStyle: {
          color: '#D9D9D9'
        }
      },
      axisLabel: {
        color: '#000',
        interval: 0,
        rotate: `${rotate}`,//标签倾斜度数
        formatter(params) {
          let str = ''
          const length = params.length
          const length2 = data.series[0].data.length
          let num = 0
          if ((/[\u4e00-\u9fa5]/gu).test(params)) {
            if (length >= 8 && length2 >= 8) {
              num = 8
            }
          } else {
            if (length >= 10 && length2 >= 8) {
              num = 10
            }
          }

          if (num) {
            const lines = Math.ceil(length / num)
            for (let i = 0; i < lines; i++) {
              str += (i ? '\n' : '') + params.slice(i * num, i * num + num)
            }
          } else {
            str = params
          }

          return str
        }
      },
    },
    // type的slider和inside可以同时保留，既可以保留滚动条，也可以在内部拖动
    dataZoom: [
      {
        type: 'inside',// 内置于坐标系中
        show: false,
        xAxisIndex: [0],
        startValue: 0,//startValue,endValue是初次展示echarts的开始和结束索引
        endValue: endValue,
        zoomLock: true,
      }
    ],
    yAxis: {
      name: ySuffix ? `单位（${ySuffix}）` : '',
      nameTextStyle: {
        color: "#dcdcdc",
        nameLocation: "start",
        fontSize: 12
      },
      type: 'value',
      axisTick: {show: false},
      axisLine: {show: false},
    },
    series: []
  }
  legendData.forEach(name => {
    data.series.push(
      {
        name: name,//需要改变的数据
        type: 'line',
        // stack: 'Total',
        data: []//需要改变的数据
      }
    )
  })
  if (legendData.length === 1) {
    data.series[0].areaStyle = {
      color: {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [
          {
            offset: 0,
            color: 'rgba(255,195,0,0.56)'
          },
          {
            offset: 1,
            color: 'rgb(248,224,145)'
          }
        ],
        global: false // 缺省为 false
      }
    }
  }
  return data
}



// WEBPACK FOOTER //
// ./src/views/szrt_revision/new_account_settings/accountSettings/overallStatistics/mixins/lineData.js